var React = require('react');

function IconDownload (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"download-button"),React.createElement("path",{"d":"M51.33,0a51,51,0,1,0,51,51A51,51,0,0,0,51.33,0Zm24.5,78h-49V71h49Zm-24-13-25-24h14V20h21V41h14Z","transform":"translate(-0.33)","style":{"fill":"currentColor"},"key":1})]);
}

IconDownload.defaultProps = {"viewBox":"0 0 102 102"};

module.exports = IconDownload;

IconDownload.default = IconDownload;
